"use client";

import { useEffect, useState } from "react";
import Logo from "./Logo";
import SelectField from "./SelectField";
import Button from "./Button";
import { useGateHold } from "./Gate";

/** 開発者用切り替えフォーム */
export default function DeveloperSwitchForm({
  onDecide,
  onCancel,
}: {
  onDecide: (world: string) => void;
  onCancel: () => void;
}) {
  const [worlds, setWorlds] = useState<string[]>([]);
  const [world, setWorld] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(true);
  // 世界の一覧を読み終えるまで、ロード画面に待ってもらう
  useGateHold(loading);

  useEffect(() => {
    let alive = true;
    fetch("/api/admin/worlds")
      .then(async (response) => {
        const body = await response.json();
        if (!alive) return;
        if (response.ok) {
          setWorlds(body.worlds as string[]);
        } else {
          setMessage(body.error ?? "世界の一覧を読めません");
        }
      })
      .catch(() => {
        if (alive) setMessage("サーバーに繋がりません");
      })
      .finally(() => {
        if (alive) setLoading(false);
      });
    return () => {
      alive = false;
    };
  }, []);

  return (
    <div className="panel panel-scene panel-select">
      <Logo />
      <form
        onSubmit={(event) => {
          event.preventDefault();
          onDecide(world);
        }}
      >
        <SelectField
          id="developer-world"
          label="世界"
          value={world}
          onChange={setWorld}
          options={worlds}
          placeholder={loading ? "読み込み中・・・" : "世界を選んでください"}
          disabled={loading || worlds.length === 0}
          required
        />

        <div className="actions">
          <Button type="submit" variant="primary" disabled={world === ""}>
            決定
          </Button>
          <Button onClick={onCancel}>キャンセル</Button>
        </div>
      </form>

      <p className="message message-info">{message}</p>
    </div>
  );
}
